import { gql, useQuery } from "@apollo/client";

const GET_PAYMENTS_PROCESSED = gql`
  query GetPaymentsProcessedPrevious(
    $region: ID
    $district: ID
    $tariffClass: ID
    $tariffClasses: [ID]
    $serviceClass: ServiceClass
    $serviceClasses: [ServiceClass]
    $month: PositiveInt!
    $year: PositiveInt!
    $page: Int
    $pageSize: Int
    $search: String
    $searchFields: [String!]
    $sort: String
  ) {
    rows: getPaymentsProcessed(
      region: $region
      district: $district
      tariffClass: $tariffClass
      tariffClasses: $tariffClasses
      serviceClass: $serviceClass
      serviceClasses: $serviceClasses
      category: ProcessedPrevious
      month: $month
      year: $year
      page: $page
      pageSize: $pageSize
      search: $search
      searchFields: $searchFields
      sort: $sort
    ) {
      _id
      servicePointCode
      servicePointStatus
      tariffClassCode
      tariffClassName
      serviceClass
      geoCode
      accountCode
      meterCode
      meterModelType
      regionCode
      regionName
      districtCode
      districtName

      customerName
      externalTransactionCode
      paymentDate
      paymentTime
      receivedDate
      receivedTime
      processedDate
      processedTime
      origin
      type
      subType
      amount

      month
      year
      createdAt
      updatedAt
    }
    count: getPaymentsProcessedCount(
      region: $region
      district: $district
      tariffClass: $tariffClass
      tariffClasses: $tariffClasses
      serviceClass: $serviceClass
      serviceClasses: $serviceClasses
      category: ProcessedPrevious
      month: $month
      year: $year
      search: $search
      searchFields: $searchFields
    )
  }
`;

export const usePaymentsProcessed = (variables: any) => {
  const { data, ...rest } = useQuery(GET_PAYMENTS_PROCESSED, {
    variables,
    notifyOnNetworkStatusChange: true,
  });
  const rows = data?.rows || [];
  const count = data?.count || 0;
  return { rows, count, ...rest };
};
